import { module as BaseModule } from "modujs"
import { DOMAnimations } from "../utils/dom"

export default class extends BaseModule {
  constructor(m) {
    super(m)
    
    // Internal state
    this.isAnimating = false
    this.isExpanded = false

  }

  init() {
    this.button = this.el.querySelector("[data-accordion-button]")
    if (!this.button) return

    this.contentId = this.button.getAttribute("aria-controls")
    this.content = document.getElementById(this.contentId)
    if (!this.content) return

    this.isExpanded = this.button.getAttribute("aria-expanded") === "true"
    this.updateAriaAttributes(this.isExpanded)
    this.syncPanelVisibility(this.isExpanded)

    requestAnimationFrame(() => {
      this.el.classList.remove("inactive")
      this.el.dataset.accordionReady = "true"
    })

    this.button.addEventListener("click", this.handleClick.bind(this))
  }

  async handleClick() {
    // Prevent multiple clicks during animation
    if (this.isAnimating) return
    
    this.isAnimating = true
    
    try {
      if (this.isExpanded) {
        await this.collapse()
      } else {
        await this.expand()
      }
    } catch (error) {
      console.error("Accordion animation error:", error)
    } finally {
      this.isAnimating = false
    }
  }

  async expand() {

    this.updateAriaAttributes(true)
    this.content.removeAttribute("hidden")
    this.content.classList.add("active")

    await DOMAnimations.slideDown(this.content, 500)

    this.syncPanelVisibility(true)
  }

  async collapse() {
    this.updateAriaAttributes(false)

    await DOMAnimations.slideUp(this.content, 500)

    this.syncPanelVisibility(false)
  }

  updateAriaAttributes(isExpanded) {
    this.button.setAttribute("aria-expanded", isExpanded ? "true" : "false")
    this.content.setAttribute("aria-hidden", isExpanded ? "false" : "true")
  }

  syncPanelVisibility(isExpanded) {
    this.isExpanded = isExpanded
    this.content.classList.toggle("active", isExpanded)

    if (isExpanded) {
      this.content.removeAttribute("hidden")
      this.content.style.removeProperty("display")
    } else {
      this.content.setAttribute("hidden", "")
      this.content.style.display = "none"
    }
  }

}
